import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from './field-config.interface';
import { hasRequiredField } from '../../../../utils/has-required-field';

export abstract class AbstractField {
  config: FieldConfig;
  group: UntypedFormGroup;
  public rtl = false;

  getControl() {
    return this.group.get(this.config.name);
  }

  hasRequiredField(abstractControl: AbstractControl): boolean {
    return hasRequiredField(abstractControl);
  }
}
